<template>
  <div class="month-report-wrap">
    <handleIcon @allScreen="toggleAllScreenFull(!isAllScreen)" :isAllScreen="isAllScreen">
      <!-- <li @click="toggleAllScreenFull(false)" v-if="isAllScreen">
        <div class="icon">
          <i class="iconfont iconquanping1"></i>
        </div>
        <span>{{ $t('dashboard-bi::default-board::screen') }}</span>
      </li>
      <li @click="toggleAllScreenFull(true)" v-else>
        <div class="icon">
          <i class="iconfont iconquanping1"></i>
        </div>
        <span>{{ $t('dashboard-bi::default-board::screen') }}</span>
      </li> -->
      <template slot="menu">
        <li @click="() => getAllData()">
          <div class="icon">
            <i class="iconfont iconRefresh"></i>
          </div>
          <span>{{ $t('dashboard-bi::default-board::refresh') }}</span>
        </li>
      </template>
    </handleIcon>
    <el-card>
      <el-row>
        <el-col>
          <label class="label-item">{{ $t('operate-analysis::month-report::shop_name') }}</label>
          <el-select
            :placeholder="$t('system::common::select_placeholder')"
            :popperAppendToBody="false"
            @change="changeShop"
            filterable
            clearable
            class="search-item"
            v-model="params.shopId"
          >
            <el-option
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
              v-for="item in shopList"
            ></el-option>
          </el-select>
          <label class="label-item">{{ $t('operate-analysis::month-report::month') }}</label>
          <!-- <el-date-picker
            :appendToBody="false"
            :clearable="false"
            @change="handlerDateChange"
          
            type="month"
            unlink-panels
            v-model="date"
          ></el-date-picker> -->
          <el-date-picker
            class="day-item"
            :appendToBody="false"
            :clearable="false"
            @change="handlerDateChange"
            v-model="date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-col>
      </el-row>
    </el-card>
    <el-row :gutter="16" :span="20" class="card-content" justify="space-between">
      <el-col :key="index" :lg="4" :md="12" :xl="4" class="card-item" v-for="(item, index) in cardOptions">
        <dataCard :active="0" :option="item" v-loading="cardLoading"></dataCard>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col v-if="reports.includes(12431)" :lg="12" :md="24" :sm="24" :xl="12">
        <reportCard
          @btns="onReportBtns"
          :config="saleTrendData"
          :style="`height: ${reportHeight};`"
          v-loading="reportCardLoading"
        ></reportCard>
      </el-col>
      <el-col :lg="12" :md="24" :sm="24" :xl="12" v-if="reports.includes(13049)">
        <reportTable
          @onEnd="onSiteTableEnd"
          @btns="onReportBtns"
          :config="siteTableConfig"
          @sort-change="siteSortChange"
          :style="`height: ${reportHeight};`"
          v-loading="loading.siteTable"
          ref="siteTable"
        >
          <template v-for="(item, index) in siteTableConfig.columns">
            <el-table-column
              :key="index"
              :label="item"
              min-width="130"
              :sortable="(item === '客单价' || item === '成交额' || item === '连带率') && 'custom'"
              :prop="item"
            >
              <template slot-scope="scope">
                <el-image
                  v-if="
                    /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                      scope.row[item]
                    )
                  "
                  :src="scope.row[item]"
                  class="goods-image"
                ></el-image>
                <span v-else>{{ $dataCheck(scope.row[item]) }}</span>
              </template>
            </el-table-column>
          </template>
        </reportTable>
      </el-col>
      <el-col v-if="reports.includes(13050)" :lg="12" :md="24" :sm="24" :xl="12">
        <reportTable
          @btns="onReportBtns"
          @onEnd="onOptimizerTableEnd"
          :config="optimizerTableConfig"
          :style="`height: ${reportHeight};`"
          v-loading="optimizerTableLoading"
          ref="optimizerTable"
        >
          <el-table-column
            prop="index"
            key="index"
            v-if="optimizerTableConfig && optimizerTableConfig.columns && optimizerTableConfig.columns.length"
            label="序号"
            min-width="60"
          >
            <template slot-scope="{ $index }">
              <span>{{ $index + 1 }}</span>
            </template>
          </el-table-column>
          <template v-for="(item, index) in optimizerTableConfig.columns">
            <el-table-column :prop="item" :key="index" :label="item" min-width="120">
              <template slot-scope="scope">
                <el-image
                  v-if="
                    /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                      scope.row[item]
                    )
                  "
                  :src="scope.row[item]"
                  class="goods-image"
                ></el-image>
                <span v-else>{{ $dataCheck(scope.row[item]) }}</span>
              </template>
            </el-table-column>
          </template>
        </reportTable>
      </el-col>
      <el-col v-if="reports.includes(12430)" :lg="12" :md="24" :sm="24" :xl="12">
        <reportTable
          @btns="onReportBtns"
          @onEnd="onSalesTableEnd"
          :config="salesTable"
          :style="`height: ${reportHeight};`"
          @sort-change="salesSortChange"
          v-loading="loading.salesTable"
          ref="salesTable"
        >
          <el-table-column
            prop="index"
            key="index"
            v-if="salesTable && salesTable.columns && salesTable.columns.length"
            label="序号"
            min-width="60"
          >
            <template slot-scope="{ $index }">
              <span>{{ $index + 1 }}</span>
            </template>
          </el-table-column>
          <template v-for="(item, index) in salesTable.columns">
            <el-table-column
              :prop="item"
              :key="index"
              :label="item"
              :sortable="(item === '销量' || item === '成交额') && 'custom'"
              min-width="120"
            >
              <template slot-scope="scope">
                <el-image
                  v-if="
                    /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                      scope.row[item]
                    )
                  "
                  :src="scope.row[item]"
                  class="goods-image"
                ></el-image>
                <span v-else>{{ $dataCheck(scope.row[item]) }}</span>
              </template>
            </el-table-column>
          </template>
        </reportTable>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import setConfig from './setConfig'
import dataCard from '@/components/data-analysis/card'
import handleIcon from '@/components/handle-icon/index.vue'
import { getShopList, getErpShopList } from '@/server/shopList'
import { getMerchantType } from '@/server/user'
// import { getErpMerchant } from '@/server/data'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
import { getReports, downloadData, queryData } from '@/server/dashboard'
import { getTableConfigData, getSalesTable } from '@/server/data'
import { getMonthCount } from '@/server/etl'
import { toggleAllScreen } from '@/utils/utils'
import { pickerOptions } from '@/utils/datepickerConfig'
export default {
  name: 'month-report-wrap',
  components: {
    reportCard,
    handleIcon,
    dataCard,
    reportTable,
  },
  mixins: [setConfig],
  data() {
    return {
      date: [moment().subtract(29, 'days'), moment()],
      params: {
        shopId: undefined,
        startDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      pickerOptions: {
        ...pickerOptions,
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        },
      },
      cardLoading: false,
      tableLoading: false,
      reportCardLoading: false,
      shopList: [{ shopName: this.$t('system::common::select_all_shop'), shopId: undefined }],
      reportHeight: '400px',
      board: 0,
      saleTrendData: {}, // 总体成交趋势图数据
      cardOptions: {}, // 月报card数据
      siteTableConfig: {}, // 站点运营数据
      selectedShop: '', // 选中的站点id
      salesTable: {}, // 商品销售排行
      salesPieEchart: {},
      buyBarEchart: {},
      optimizerTableConfig: {},
      optimizerTableLoading: false,
      boardData: [],
      reports: [13049, 12430, 13050, 12431],
      loading: {
        salesTable: false,
        siteTable: false,
        salesPieEchart: false,
        putTable: false,
        buyBarEchart: false,
      },
    }
  },
  computed: {
    isAllScreen() {
      return this.$store.state.isAllScreen
    },
    merchantId() {
      return this.$store.state.user.merchantId
    },
  },
  methods: {
    /**
     * @name: 下载报表
     * @param {*} reportId 报表id
     * @param {*} target 目标报表对象 如： salesTable
     * @param {*} name 下载报表名称
     * @return {*}
     */
    async downLoadReportData(reportId, target, name) {
      if (this[target].btns) {
        this.$set(
          this[target],
          'btns',
          this.$deepClone(
            this[target].btns.map(item => {
              if (item.call == 'download') {
                item.loading = true
              }
              return item
            })
          )
        )
      }
      const res = await downloadData(
        this.setParamsReport(
          this.boardData.find(item => item.reportID == reportId),
          {
            ...this.params,
            org_unit_id: this.merchantId,
          }
        ),
        name,
        getCookie('saasToken'),
        () => {
          if (this[target].btns) {
            const data = this.$deepClone(
              this[target].btns.map(item => {
                if (item.call == 'download') {
                  item.loading = false
                }
                return item
              })
            )
            this.$set(this[target], 'btns', data)
          }
        }
      )
    },
    // 报表数据构建Init
    async setReportQueryInit(boardID, callback) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID,
        })
        if (!res.result[0]) {
          return false
        }
        this.boardData = res.result
        this.reports = this.reports.filter(item => res.result.map(report => report.reportID).includes(item))
      }

      callback()
    },
    // 报表数据构建
    async setReportQuery(boardID, reportId, callback, offset, sort) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID,
        })
        if (!res.result[0]) {
          return false
        }
        this.boardData = res.result
        this.reports = this.reports.filter(item => res.result.map(report => report.reportID).includes(item))
      }
      // 12420 店铺， 12419 分时监控
      const data = await queryData(
        this.setParamsReport(
          this.boardData.find(item => item.reportID == reportId),
          {
            ...this.params,
          },
          offset,
          sort
        )
      )
      callback(data)
    },
    // 构建report请求
    setParamsReport(result, params = {}, offset, sort) {
      // 配置params 别名
      const alias = []
      // 是否有时间匹配
      if (params.startDate && params.endDate) {
        alias.push('pay_date')
      }
      if (params.shopId) {
        alias.push('brand_id')
      }
      const dimensions = sort
        ? result.requestDimensions.map(el => {
            if (sort && sort.name === el.chinese) {
              return { ...el, sortType: sort.type }
            } else {
              return { ...el, sortType: 'DEFAULT' }
            }
          })
        : result.requestDimensions // 堆积过滤条件concat 条件conditions
      const filters = result.otherParams.filter // 过滤条件，用alias取对应的uuid
      const pageSize = result.otherParams.pageSize
      let conditions = result.requestConditions
      const dirlls = result.drillDimensions
      const measures = sort
        ? result.requestMeasures.map(el => {
            if (sort && sort.name === el.chinese) {
              return { ...el, sortType: sort.type }
            } else {
              return { ...el, sortType: 'DEFAULT' }
            }
          })
        : result.requestMeasures

      // 判断alias 是否匹配到filters值
      alias.forEach(alia => {
        if (filters.some(item => alia == item.alias)) {
          const conditionItem = filters.find(item => alia == item.alias) || {}

          if (conditionItem.columnType == 'DATE') {
            conditions = conditions
              .filter(item => item.requestValue.length)
              .filter(item => item.uuid != conditionItem.uuid)
            conditions.push({
              queryType: 'LARGEEQUAL',
              requestValue: [moment(params.startDate).format('YYYY-MM-DD')],
              uuid: conditionItem.uuid,
            })
            conditions.push({
              queryType: 'LESSEQUAL',
              requestValue: [moment(params.endDate).format('YYYY-MM-DD')],
              uuid: conditionItem.uuid,
            })
          } else {
            conditions = conditions
              .filter(item => item.requestValue.length)
              .filter(item => item.uuid != conditionItem.uuid)
            const filterItem = filters.find(item => alia == item.alias)
            let queryType = ''
            if (filterItem) {
              queryType = filterItem.filterGroup.filterType.split('-')[1].toUpperCase()
            }
            conditions.push({
              queryType,
              requestValue: [String(params.shopId)],
              uuid: conditionItem.uuid,
            })
          }
        }
      })

      return {
        check: false,
        conditions,
        modelID: result.modelID,
        offSet: offset || 1,
        pageSize,
        reportID: result.reportID,
        dimensions,
        measures,
        dirlls,
      }
    },
    /**
     * @name: 报表操作按钮事件
     * @param {*} emit
     * @return {*}
     */
    onReportBtns(emit) {
      if (emit.call == 'download') {
        this.downLoadReportData(emit.reportId, emit.target, emit.title)
      }
    },
    getAllData(init) {
      if (!init) {
        this.getCardOptions()
      }
      this.getSaleTrendData()
      this.getSiteTableConfig()
      this.getOptimizerTable()
      this.getSalesTable()
    },
    changeShop() {
      this.siteTableConfig = {}
      this.salesTable = {}
      this.optimizerTableConfig = {}
      this.getAllData()
    },
    handlerDateChange(date) {
      this.params.startDate = moment(date[0]).format('YYYY-MM-DD')
      this.params.endDate = moment(date[1]).format('YYYY-MM-DD')
      // this.params.dt = moment(date).format('YYYY-MM')
      this.siteTableConfig = {}
      this.salesTable = {}
      this.optimizerTableConfig = {}
      this.getAllData()
    },
    async getShopList() {
      const res = await getMerchantType(this.$store.state.user.merchantId)
      if (res.data.code === this.$code) {
        if (res.data.data === 1) {
          const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
          if (data.code === this.$code) {
            this.shopList = [...this.shopList, ...((data.data && data.data.items) || [])]
          }
        } else if (res.data.data === 2) {
          const { data } = await getErpShopList(this.merchantId)
          if (data.code === this.$code) {
            this.shopList = [...this.shopList, ...(data.data || [])]
          }
        }
      }
    },
    // 总体成交趋势
    async getSaleTrendData() {
      const reportId = 12431
      if (!this.reports.includes(reportId)) {
        return false
      }
      this.reportCardLoading = true
      this.setReportQuery(1, reportId, data => {
        if (data.status === 200) {
          this.saleTrendData = this.setSaleTrendData(data.result.lineAndBar, reportId)
        }
        this.reportCardLoading = false
      })
    },
    // 月报card数据
    async getCardOptions() {
      this.cardLoading = true
      let obj = {
        ...this.params,
        org_unit_id: this.merchantId,
      }
      const { data } = await getMonthCount(obj)
      if (data.code === this.$code) {
        this.cardOptions = this.setMonthCount(data.data.datas[0] || {})
      }
      this.cardLoading = false
    },
    // 站点运营概括
    async getSiteTableConfig(offset) {
      const reportId = 13049
      if (!this.reports.includes(reportId)) {
        return false
      }
      if (offset && !this.siteTableConfig.last) {
        this.siteTableConfig.offsetLoading = true
        offset = this.siteTableConfig.offset + 1
      } else {
        this.loading.siteTable = true
      }
      this.setReportQuery(
        1,
        reportId,
        data => {
          if (data.status === 200) {
            this.siteTableConfig = this.setSiteTableConfig(
              data.result.table,
              reportId,
              offset,
              this.siteTableConfig,
              data.last
            )
            if (offset && !this.siteTableConfig.last) {
              this.siteTableConfig.offsetLoading = false
            }
          }
          this.loading.siteTable = false
        },
        offset,
        this.siteTableConfig.sort || null
      )
    },
    async getOptimizerTable(offset) {
      const reportId = 13050
      if (!this.reports.includes(reportId)) {
        return false
      }
      if (offset && !this.optimizerTableConfig.last) {
        this.optimizerTableConfig.offsetLoading = true
        offset = this.optimizerTableConfig.offset + 1
      } else {
        this.optimizerTableLoading = true
      }
      this.setReportQuery(
        1,
        reportId,
        data => {
          if (data.status === 200) {
            this.optimizerTableConfig = this.setOptimizerTableConfig(
              data.result.table,
              reportId,
              offset,
              this.optimizerTableConfig,
              data.last
            )
            if (offset && !this.optimizerTableConfig.last) {
              this.optimizerTableConfig.offsetLoading = false
            }
          }
          this.optimizerTableLoading = false
        },
        offset,
        { name: '成交额', type: 'DESC' }
      )
    },
    async onSiteTableEnd() {
      if (this.siteTableConfig.last) {
        return
      }
      this.getSiteTableConfig(1)
    },
    async onOptimizerTableEnd() {
      if (this.optimizerTableConfig.last) {
        return
      }
      this.getOptimizerTable(1)
    },
    async onSalesTableEnd() {
      if (this.salesTable.last) {
        return
      }
      this.getSalesTable(1)
    },
    // 商品销售排行
    async getSalesTable(offset) {
      const reportId = 12430
      if (!this.reports.includes(reportId)) {
        return false
      }
      if (offset && !this.salesTable.last) {
        this.salesTable.offsetLoading = true
        offset = this.salesTable.offset + 1
      } else {
        this.loading.salesTable = true
      }
      this.setReportQuery(
        1,
        reportId,
        data => {
          if (data.status === 200) {
            this.salesTable = this.setSalesTableConfig(data.result.table, reportId, offset, this.salesTable, data.last)
            console.log(this.salesTable)
            if (offset) {
              this.salesTable.offsetLoading = false
            }
          }
          this.loading.salesTable = false
        },
        offset,
        this.salesTable.sort || null
      )
    },
    toggleAllScreenFull(bool) {
      this.$store.commit('setScreen', bool)
      toggleAllScreen()
    },
    sortChange(data) {},
    salesSortChange(data) {
      this.salesTable.offset = 1
      this.salesTable.tableData = []
      this.$refs.salesTable.$refs.salesTable.bodyWrapper.scrollTop = 0
      const type = { descending: 'DESC', ascending: 'ASC' }
      if (data.order) {
        this.salesTable.sort = { name: data.prop, type: type[data.order] }
      } else {
        this.salesTable.sort = null
      }
      this.getSalesTable()
    },
    siteSortChange(data) {
      this.siteTableConfig.offset = 1
      this.siteTableConfig.tableData = []
      this.$refs.siteTable.$refs.siteTable.bodyWrapper.scrollTop = 0
      const type = { descending: 'DESC', ascending: 'ASC' }
      if (data.order) {
        this.siteTableConfig.sort = { name: data.prop, type: type[data.order] }
      } else {
        this.siteTableConfig.sort = null
      }
      this.getSiteTableConfig()
    },
    optimizerSortChange(data) {
      this.optimizerTableConfig.offset = 1
      this.optimizerTableConfig.tableData = []
      this.$refs.optimizerTable.$refs.optimizerTable.bodyWrapper.scrollTop = 0
      const type = { descending: 'DESC', ascending: 'ASC' }
      if (data.order) {
        this.optimizerTableConfig.sort = { name: data.prop, type: type[data.order] }
      } else {
        this.optimizerTableConfig.sort = null
      }
      this.getOptimizerTable()
    },
  },
  async mounted() {
    this.cardOptions = this.setMonthCount({})
    await this.getShopList()
    this.setReportQueryInit(1, this.getAllData)
  },
}
</script>

<style lang="scss" scoped>
.month-report-wrap {
  position: relative;
  z-index: 8;
}
.control-btn-wrap {
  text-align: right;
  margin-bottom: 8px;
  .item-btn {
    margin-left: 16px;
  }
}
.label-item {
  margin-right: 8px;
}
.search-item {
  margin-right: 16px;
  width: 180px;
}
.day-item {
  width: 260px;
}

@media screen and (min-width: 1200px) {
  .card-item {
    width: 20%;
  }
}
.card-content {
  margin-top: 10px;
}
/deep/.el-date-editor .el-range__icon {
  color: #999999;
}
.goods-image {
  width: 64px;
  height: 64px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
}
</style>
